import { render, staticRenderFns } from "./SupportSnippet.vue?vue&type=template&id=8fa3900a&scoped=true"
import script from "./SupportSnippet.vue?vue&type=script&lang=js"
export * from "./SupportSnippet.vue?vue&type=script&lang=js"
import style0 from "./SupportSnippet.vue?vue&type=style&index=0&id=8fa3900a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa3900a",
  null
  
)

export default component.exports